export const config = {
  apiKey: 'AIzaSyBEhHNc5nB0uo2GR1OKTtPXBUeF-Kv5Iu0',
  authDomain: 'boneheads-io.firebaseapp.com',
  projectId: 'boneheads-io',
  storageBucket: 'boneheads-io.appspot.com',
  messagingSenderId: '752465678325',
  appId: '1:752465678325:web:3df93a084d0820d03adabc',
  measurementId: 'G-M4HQK2HN31',
};
